import React from 'react';
import {TCustomIcon, TCustomIconProps} from "../interfaces";

export const FactoryIcon: TCustomIcon = ({ active }: TCustomIconProps) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M4.00391 21C5.15091 16.98 5.98691 12.973 6.00391 9H12.0039C12.0209 12.973 12.8569 16.98 14.0039 21"
            stroke={active ? '#DCFF00' : 'white'}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.5 12.9995H17C17.025 15.6115 17.894 18.2955 19 20.9995M9 4.99955C9.22717 4.68306 9.52797 4.42662 9.87642 4.2524C10.2249 4.07817 10.6105 3.99139 11 3.99955C11.3895 3.99139 11.7751 4.07817 12.1236 4.2524C12.472 4.42662 12.7728 4.68306 13 4.99955C13.2272 5.31604 13.528 5.57248 13.8764 5.7467C14.2249 5.92093 14.6105 6.00771 15 5.99955C15.3895 6.00771 15.7751 5.92093 16.1236 5.7467C16.472 5.57248 16.7728 5.31604 17 4.99955C17.2272 4.68306 17.528 4.42662 17.8764 4.2524C18.2249 4.07817 18.6105 3.99139 19 3.99955C19.3895 3.99139 19.7751 4.07817 20.1236 4.2524C20.472 4.42662 20.7728 4.68306 21 4.99955M3 20.9995H22"
            stroke={active ? '#DCFF00' : 'white'}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const PhoneIcon: TCustomIcon = ({ active }: TCustomIconProps) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M17.7071 13.7071L20.3552 16.3552C20.7113 16.7113 20.7113 17.2887 20.3552 17.6448C18.43 19.57 15.3821 19.7866 13.204 18.153L11.6286 16.9714C9.88504 15.6638 8.33622 14.115 7.02857 12.3714L5.84701 10.796C4.21341 8.61788 4.43001 5.56999 6.35523 3.64477C6.71133 3.28867 7.28867 3.28867 7.64477 3.64477L10.2929 6.29289C10.6834 6.68342 10.6834 7.31658 10.2929 7.70711L9.27175 8.72825C9.10946 8.89054 9.06923 9.13846 9.17187 9.34373C10.3585 11.7171 12.2829 13.6415 14.6563 14.8281C14.8615 14.9308 15.1095 14.8905 15.2717 14.7283L16.2929 13.7071C16.6834 13.3166 17.3166 13.3166 17.7071 13.7071Z"
            stroke={active ? '#DCFF00' : 'white'}
        />
    </svg>
);

export const HelpIcon: TCustomIcon = ({ active }: TCustomIconProps) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M13.7365 21.8481C15.0297 21.62 16.2654 21.1395 17.373 20.4339C18.4806 19.7283 19.4383 18.8115 20.1915 17.7358C20.9448 16.66 21.4787 15.4465 21.763 14.1644C22.0472 12.8823 22.0761 11.5568 21.8481 10.2635C21.62 8.97025 21.1395 7.73456 20.4339 6.627C19.7283 5.51945 18.8115 4.56171 17.7358 3.80848C16.66 3.05525 15.4465 2.52127 14.1644 2.23704C12.8823 1.95281 11.5568 1.92388 10.2635 2.15192C8.97025 2.37996 7.73456 2.86049 6.627 3.56609C5.51945 4.27168 4.56171 5.18851 3.80848 6.26424C3.05525 7.33996 2.52127 8.55352 2.23704 9.83561C1.95281 11.1177 1.92388 12.4432 2.15192 13.7365C2.37996 15.0298 2.86049 16.2654 3.56609 17.373C4.27168 18.4806 5.18851 19.4383 6.26424 20.1915C7.33996 20.9448 8.55352 21.4787 9.83561 21.763C11.1177 22.0472 12.4432 22.0761 13.7365 21.8481L13.7365 21.8481Z"
            stroke={active ? '#DCFF00' : 'white'}
        />
        <path
            d="M12 12L12 18"
            stroke={active ? '#DCFF00' : 'white'}
            strokeLinecap="square"
        />
        <path
            d="M12 7L12 6"
            stroke={active ? '#DCFF00' : 'white'}
            strokeLinecap="square"
        />
    </svg>
);

export const LoginIcon: TCustomIcon = ({ active }: TCustomIconProps) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M7 7.13193V6.61204C7 4.46614 7 3.3932 7.6896 2.79511C8.37919 2.19703 9.44136 2.34877 11.5657 2.65224L15.8485 3.26408C18.3047 3.61495 19.5327 3.79039 20.2664 4.63628C21 5.48217 21 6.72271 21 9.20377V14.7962C21 17.2773 21 18.5178 20.2664 19.3637C19.5327 20.2096 18.3047 20.385 15.8485 20.7359L11.5657 21.3478C9.44136 21.6512 8.37919 21.803 7.6896 21.2049C7 20.6068 7 19.5339 7 17.388V17.066"
            stroke={active ? '#DCFF00' : 'white'}
        />
        <path
            d="M16 12L16.3904 11.6877L16.6403 12L16.3904 12.3123L16 12ZM4 12.5C3.72386 12.5 3.5 12.2761 3.5 12C3.5 11.7239 3.72386 11.5 4 11.5V12.5ZM12.3904 6.68765L16.3904 11.6877L15.6096 12.3123L11.6096 7.31235L12.3904 6.68765ZM16.3904 12.3123L12.3904 17.3123L11.6096 16.6877L15.6096 11.6877L16.3904 12.3123ZM16 12.5H4V11.5H16V12.5Z"
            fill={active ? '#DCFF00' : 'white'}
        />
    </svg>
);

export const UserIcon: TCustomIcon = ({ active }: TCustomIconProps) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M19.7274 19.9294C19.2716 18.2284 18.2672 16.7252 16.8701 15.6532C15.4729 14.5811 13.7611 14 12 14C10.2389 14 8.52706 14.5811 7.12991 15.6532C5.73276 16.7252 4.72839 18.2284 4.27259 19.9294"
            stroke={active ? '#DCFF00' : 'white'}
            strokeLinecap="round"
        />
        <circle
            cx="12"
            cy="8"
            r="3.5"
            stroke={active ? '#DCFF00' : 'white'}
            strokeLinecap="round"
        />
    </svg>
);

export const PlaceIcon: TCustomIcon = ({ active }: TCustomIconProps) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M19.3612 17C20.1072 17.4561 20.5 17.9734 20.5 18.5C20.5 19.0266 20.1072 19.5439 19.3612 20C18.6152 20.4561 17.5422 20.8348 16.25 21.0981C14.9578 21.3614 13.4921 21.5 12 21.5C10.5079 21.5 9.04216 21.3614 7.75 21.0981C6.45784 20.8348 5.38482 20.4561 4.63878 20C3.89275 19.5439 3.5 19.0266 3.5 18.5C3.5 17.9734 3.89275 17.4561 4.63878 17"
            stroke={active ? '#DCFF00' : 'white'}
            strokeLinecap="round"
        />
        <path
            d="M19.5 10C19.5 15.018 14.0117 18.4027 12.4249 19.2764C12.1568 19.424 11.8432 19.424 11.5751 19.2764C9.98831 18.4027 4.5 15.018 4.5 10C4.5 5.5 8.13401 2.5 12 2.5C16 2.5 19.5 5.5 19.5 10Z"
            stroke={active ? '#DCFF00' : 'white'}
        />
        <circle
            cx="12"
            cy="10"
            r="3.5"
            stroke={active ? '#DCFF00' : 'white'}
        />
    </svg>
);

export const CatalogGridIcon: TCustomIcon = ({ active }: TCustomIconProps) => (
    <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect
            x="4.67188"
            y="4.6665"
            width="7"
            height="7"
            rx="1"
            stroke={active ? '#FFFFFF' : '#7B7C7D'}
            strokeLinejoin="round"
        />
        <rect
            x="4.67188"
            y="16.3335"
            width="7"
            height="7"
            rx="1"
            stroke={active ? '#FFFFFF' : '#7B7C7D'}
            strokeLinejoin="round"
        />
        <rect
            x="16.3281"
            y="16.3335"
            width="7"
            height="7"
            rx="1"
            stroke={active ? '#FFFFFF' : '#7B7C7D'}
            strokeLinejoin="round"
        />
        <rect
            x="16.3281"
            y="4.6665"
            width="7"
            height="7"
            rx="1"
            stroke={active ? '#FFFFFF' : '#7B7C7D'}
            strokeLinejoin="round"
        />
    </svg>
);

export const CatalogListIcon: TCustomIcon = ({ active }: TCustomIconProps) => (
    <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M5.82812 8.1665H22.1615"
            stroke={active ? '#FFFFFF' : '#7B7C7D'}
            strokeLinecap="round"
        />
        <path
            d="M5.82812 14H22.1615"
            stroke={active ? '#FFFFFF' : '#7B7C7D'}
            strokeLinecap="round"
        />
        <path
            d="M5.82812 19.8335H22.1615"
            stroke={active ? '#FFFFFF' : '#7B7C7D'}
            strokeLinecap="round"
        />
    </svg>
);

export const LeftOutlined = () => ( // TODO: china icon replace
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        {/*<g clip-path="url(#clip0_5205_65269)">*/}
        {/*    <path d="M0 0H24V24H0V0Z" fill="#D80027"/>*/}
        {/*    <path fill-rule="evenodd" clip-rule="evenodd"*/}
        {/*          d="M14.1656 6.6373L14.2594 5.38574L13.4484 6.34668L12.2812 5.87324L12.9469 6.9373L12.1359 7.89824L13.3594 7.59824L14.0203 8.66699L14.1094 7.41074L15.3328 7.11074L14.1656 6.6373ZM6.56719 7.30293L7.60312 10.4904H10.9547L8.24531 12.4639L9.28125 15.6514L6.56719 13.6826L3.85312 15.6514L4.89375 12.4639L2.17969 10.4904H5.53125L6.56719 7.30293ZM14.2266 18.5857L13.4344 17.6107L12.2625 18.0654L12.9422 17.0107L12.15 16.0311L13.3641 16.3545L14.0484 15.2998L14.1141 16.5561L15.3328 16.8795L14.1562 17.3295L14.2266 18.5857ZM16.1766 14.5264L15.8016 15.7264L16.8094 14.9717L17.8359 15.6982L17.4328 14.5076L18.4406 13.7576L17.1844 13.7717L16.7766 12.5811L16.4062 13.7811L15.15 13.7998L16.1766 14.5264ZM17.925 8.80762L17.3719 9.9373L18.2719 10.8139L17.0297 10.6357L16.4766 11.7607L16.2609 10.5232L15.0141 10.3451L16.1297 9.75918L15.9141 8.51699L16.8141 9.39355L17.925 8.80762Z"*/}
        {/*          fill="#FFDA44"/>*/}
        {/*</g>*/}
        {/*<defs>*/}
        {/*    <clipPath id="clip0_5205_65269">*/}
        {/*        <rect width="24" height="24" fill="white"/>*/}
        {/*    </clipPath>*/}
        {/*</defs>*/}
    </svg>
)

export const ArrowRightOutlined = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M20 12L20.3536 11.6464L20.7071 12L20.3536 12.3536L20 12ZM5 12.5C4.72386 12.5 4.5 12.2761 4.5 12C4.5 11.7239 4.72386 11.5 5 11.5V12.5ZM14.3536 5.64645L20.3536 11.6464L19.6464 12.3536L13.6464 6.35355L14.3536 5.64645ZM20.3536 12.3536L14.3536 18.3536L13.6464 17.6464L19.6464 11.6464L20.3536 12.3536ZM20 12.5H5V11.5H20V12.5Z"
            fill="#8D24F8"/>
    </svg>
)

export const CloseOutlined = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="4" width="6" height="6" rx="1" stroke="#0B0B0C" stroke-linejoin="round"/>
        <rect x="4" y="14" width="6" height="6" rx="1" stroke="#0B0B0C" stroke-linejoin="round"/>
        <rect x="14" y="14" width="6" height="6" rx="1" stroke="#0B0B0C" stroke-linejoin="round"/>
        <rect x="14" y="4" width="6" height="6" rx="1" stroke="#0B0B0C" stroke-linejoin="round"/>
    </svg>
)

export const LoadingOutlined = () => ( // TODO: china icon replace
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        {/*<g clip-path="url(#clip0_5205_65269)">*/}
        {/*    <path d="M0 0H24V24H0V0Z" fill="#D80027"/>*/}
        {/*    <path fill-rule="evenodd" clip-rule="evenodd"*/}
        {/*          d="M14.1656 6.6373L14.2594 5.38574L13.4484 6.34668L12.2812 5.87324L12.9469 6.9373L12.1359 7.89824L13.3594 7.59824L14.0203 8.66699L14.1094 7.41074L15.3328 7.11074L14.1656 6.6373ZM6.56719 7.30293L7.60312 10.4904H10.9547L8.24531 12.4639L9.28125 15.6514L6.56719 13.6826L3.85312 15.6514L4.89375 12.4639L2.17969 10.4904H5.53125L6.56719 7.30293ZM14.2266 18.5857L13.4344 17.6107L12.2625 18.0654L12.9422 17.0107L12.15 16.0311L13.3641 16.3545L14.0484 15.2998L14.1141 16.5561L15.3328 16.8795L14.1562 17.3295L14.2266 18.5857ZM16.1766 14.5264L15.8016 15.7264L16.8094 14.9717L17.8359 15.6982L17.4328 14.5076L18.4406 13.7576L17.1844 13.7717L16.7766 12.5811L16.4062 13.7811L15.15 13.7998L16.1766 14.5264ZM17.925 8.80762L17.3719 9.9373L18.2719 10.8139L17.0297 10.6357L16.4766 11.7607L16.2609 10.5232L15.0141 10.3451L16.1297 9.75918L15.9141 8.51699L16.8141 9.39355L17.925 8.80762Z"*/}
        {/*          fill="#FFDA44"/>*/}
        {/*</g>*/}
        {/*<defs>*/}
        {/*    <clipPath id="clip0_5205_65269">*/}
        {/*        <rect width="24" height="24" fill="white"/>*/}
        {/*    </clipPath>*/}
        {/*</defs>*/}
    </svg>
)

export const MinusCircleOutlined = ({onClick}: any) => ( // TODO: cross replace to minus
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18" stroke="#7B7C7D" strokeLinecap="square" stroke-linejoin="round"/>
        <path d="M6 6L18 18" stroke="#7B7C7D" strokeLinecap="square" stroke-linejoin="round"/>
    </svg>

)

export const CheckOutlined = () => (
    <svg style={{minHeight: '24px', minWidth: '24px'}} width="24" height="24" viewBox="0 0 24 24" fill="none"
         xmlns="http://www.w3.org/2000/svg">
        <path d="M5 14L8.23309 16.4248C8.66178 16.7463 9.26772 16.6728 9.60705 16.2581L18 6" stroke="#8D24F8"
              strokeWidth="2" strokeLinecap="round"/>
    </svg>
)

export const ProductOutlined = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="4" width="6" height="6" rx="1" stroke="#0B0B0C" stroke-linejoin="round"/>
        <rect x="4" y="14" width="6" height="6" rx="1" stroke="#0B0B0C" stroke-linejoin="round"/>
        <rect x="14" y="14" width="6" height="6" rx="1" stroke="#0B0B0C" stroke-linejoin="round"/>
        <rect x="14" y="4" width="6" height="6" rx="1" stroke="#0B0B0C" stroke-linejoin="round"/>
    </svg>
)

export const PlusOutlined = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3 11C3 7.22876 3 5.34315 4.17157 4.17157C5.34315 3 7.22876 3 11 3H13C16.7712 3 18.6569 3 19.8284 4.17157C21 5.34315 21 7.22876 21 11V13C21 16.7712 21 18.6569 19.8284 19.8284C18.6569 21 16.7712 21 13 21H11C7.22876 21 5.34315 21 4.17157 19.8284C3 18.6569 3 16.7712 3 13V11Z"
            stroke="#222222"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M18.9976 14.2904L18.6544 13.9471L18.6385 13.9313C18.238 13.5307 17.9149 13.2077 17.6314 12.9687C17.3394 12.7226 17.055 12.5353 16.7221 12.4349C16.2512 12.2928 15.7488 12.2928 15.2779 12.4349C14.945 12.5353 14.6606 12.7226 14.3686 12.9687C14.0851 13.2077 13.762 13.5307 13.3615 13.9313L13.3456 13.9471C13.0459 14.2469 12.8458 14.4462 12.6832 14.5807C12.5218 14.7142 12.452 14.7359 12.4237 14.7408C12.3029 14.762 12.1785 14.7381 12.0742 14.6735C12.0498 14.6584 11.993 14.6123 11.8928 14.4285C11.7917 14.2432 11.68 13.9838 11.513 13.5942L11.4596 13.4696L11.4475 13.4414L11.4475 13.4414C11.0829 12.5907 10.7931 11.9144 10.5107 11.4126C10.2237 10.9026 9.90522 10.4984 9.44575 10.268C9.03426 10.0618 8.57382 9.97308 8.11515 10.0118C7.603 10.055 7.15716 10.3121 6.70134 10.6789C6.25273 11.04 5.73245 11.5603 5.07799 12.2148L5.07798 12.2148L5.05634 12.2364L5 12.2928V12.9999C5 13.2462 5.00007 13.4816 5.00044 13.7065L5.76344 12.9435C6.44443 12.2626 6.92686 11.7811 7.32835 11.458C7.72756 11.1366 7.98255 11.0265 8.19924 11.0082C8.47444 10.985 8.75071 11.0382 8.9976 11.162C9.192 11.2594 9.38786 11.4564 9.63918 11.903C9.89194 12.3521 10.1611 12.9783 10.5404 13.8635L10.5938 13.9881L10.6034 14.0105L10.6034 14.0105C10.7583 14.3719 10.8884 14.6754 11.0149 14.9073C11.1448 15.1455 11.3038 15.3727 11.5479 15.5238C11.8608 15.7175 12.2341 15.7894 12.5966 15.7258C12.8794 15.6761 13.1114 15.5242 13.3204 15.3513C13.524 15.183 13.7575 14.9495 14.0355 14.6714L14.0527 14.6542C14.4728 14.2341 14.766 13.9416 15.013 13.7334C15.2553 13.5292 15.4185 13.437 15.5667 13.3922C15.8493 13.307 16.1507 13.307 16.4333 13.3922C16.5815 13.437 16.7447 13.5292 16.987 13.7334C17.234 13.9416 17.5272 14.2341 17.9473 14.6542L18.9755 15.6825C18.9887 15.2721 18.9948 14.812 18.9976 14.2904Z"
              fill="#222222"/>
        <circle cx="16.5" cy="7.5" r="1.5" fill="#222222"/>
    </svg>
)

export const QuestionCircleOutlined = () => ( // TODO: china icon replace
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#clip0_5205_65269)">
            <path d="M0 0H24V24H0V0Z" fill="#D80027"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M14.1656 6.6373L14.2594 5.38574L13.4484 6.34668L12.2812 5.87324L12.9469 6.9373L12.1359 7.89824L13.3594 7.59824L14.0203 8.66699L14.1094 7.41074L15.3328 7.11074L14.1656 6.6373ZM6.56719 7.30293L7.60312 10.4904H10.9547L8.24531 12.4639L9.28125 15.6514L6.56719 13.6826L3.85312 15.6514L4.89375 12.4639L2.17969 10.4904H5.53125L6.56719 7.30293ZM14.2266 18.5857L13.4344 17.6107L12.2625 18.0654L12.9422 17.0107L12.15 16.0311L13.3641 16.3545L14.0484 15.2998L14.1141 16.5561L15.3328 16.8795L14.1562 17.3295L14.2266 18.5857ZM16.1766 14.5264L15.8016 15.7264L16.8094 14.9717L17.8359 15.6982L17.4328 14.5076L18.4406 13.7576L17.1844 13.7717L16.7766 12.5811L16.4062 13.7811L15.15 13.7998L16.1766 14.5264ZM17.925 8.80762L17.3719 9.9373L18.2719 10.8139L17.0297 10.6357L16.4766 11.7607L16.2609 10.5232L15.0141 10.3451L16.1297 9.75918L15.9141 8.51699L16.8141 9.39355L17.925 8.80762Z"
                  fill="#FFDA44"/>
        </g>
        <defs>
            <clipPath id="clip0_5205_65269">
                <rect width="24" height="24" fill="white"/>
            </clipPath>
        </defs>
    </svg>
)

export const RightOutlined = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 6L15 12L9 18" stroke="#8D24F8"/>
    </svg>
)

export const DeleteTwoTone = ({twoToneColor}: any) => ( // TODO: china icon replace
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#clip0_5205_65269)">
            <path d="M0 0H24V24H0V0Z" fill="#D80027"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M14.1656 6.6373L14.2594 5.38574L13.4484 6.34668L12.2812 5.87324L12.9469 6.9373L12.1359 7.89824L13.3594 7.59824L14.0203 8.66699L14.1094 7.41074L15.3328 7.11074L14.1656 6.6373ZM6.56719 7.30293L7.60312 10.4904H10.9547L8.24531 12.4639L9.28125 15.6514L6.56719 13.6826L3.85312 15.6514L4.89375 12.4639L2.17969 10.4904H5.53125L6.56719 7.30293ZM14.2266 18.5857L13.4344 17.6107L12.2625 18.0654L12.9422 17.0107L12.15 16.0311L13.3641 16.3545L14.0484 15.2998L14.1141 16.5561L15.3328 16.8795L14.1562 17.3295L14.2266 18.5857ZM16.1766 14.5264L15.8016 15.7264L16.8094 14.9717L17.8359 15.6982L17.4328 14.5076L18.4406 13.7576L17.1844 13.7717L16.7766 12.5811L16.4062 13.7811L15.15 13.7998L16.1766 14.5264ZM17.925 8.80762L17.3719 9.9373L18.2719 10.8139L17.0297 10.6357L16.4766 11.7607L16.2609 10.5232L15.0141 10.3451L16.1297 9.75918L15.9141 8.51699L16.8141 9.39355L17.925 8.80762Z"
                  fill="#FFDA44"/>
        </g>
        <defs>
            <clipPath id="clip0_5205_65269">
                <rect width="24" height="24" fill="white"/>
            </clipPath>
        </defs>
    </svg>
)